<template>
  <div class="tw-mb-2 tw-block">
    <slot name="input-label">
      <label class="tw-block tw-text-sm tw-mb-2 opacity-78" :for="name" :aria-label="name">
        {{ label }}
      </label>
    </slot>
    <label v-if="instruct.length > 0" class="tw-block tw-text-xs tw-mb-2 tw--mt-3 opacity-54">
      {{ instruct }}
    </label>

    <div class="tw-flex tw-items-stretch">
      <v-select
        class="my-select my-select--py-3 tw-w-full transition tw-flex-shrink tw-flex-grow-0"
        placeholder="+254"
        v-model="dialCode"
        :options="dialCodes"
        :multiple="false"
        :clearable="false"
        :reduce="r => r.id"
        filterable
        searchable
        append-to-body
        :calculate-position="dropdownPosition"
        style="max-width: 130px"
      />

      <BaseInput
        :id="id"
        :class="inputClasses"
        type="number"
        :name="name"
        :placeholder="placeholder"
        v-model="phoneNumber"
      />
    </div>
      <!-- :name="name" -->
    <slot name="message" />
    <slot name="error-message">
      <p class="tw-text-red-500 tw-text-xs tw-italic" v-if="showError" slot> {{ error }} </p>
    </slot>
  </div>
</template>

<script>
import BaseInput from '@/components/BaseInput.vue';


export default {
  name: 'PhoneNumberInput',
  components: {
    BaseInput,
  },
  props: {
    label: {
      type: String,
      default: '',
      required: false,
    },
    instruct: {
      type: String,
      default: '',
      required: false,
    },
    id: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: false,
    },
    value: {
      default: undefined,
    },
    inputClasses: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    error: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      phoneNumber: undefined,
      dialCode: undefined,
      dialCodes: [],
    };
  },
  computed: {
    showError() {
      return this.error.length > 0;
    },
    inputValue() {
      return `${this.dialCode}${this.phoneNumber}`;
    },
  },
  watch: {
    inputValue(val) {
      if (this.dialCode && this.phoneNumber) {
        this.$emit('input', val);
      } else {
        this.$emit('input', undefined);
      }
    },
  },
  async created() {
    const dialCodes = await (await fetch('/data/dial-codes--no-plus.json')).json();
    // split this.value to dialCode and number
    //

    Object.entries(dialCodes).forEach(([code, num]) => {
      // const found = this.dialCodes.find(n => n.id === num);
      if (num && (!this.dialCodes.find(n => n.id === num))) {
        this.dialCodes.push({
          id: num,
          label: `(${code}) +${num}`,
        });
      }
    });
  },
};
</script>

<style>

</style>
